// extracted by mini-css-extract-plugin
module.exports = {"dailyLimitWarning":"Warnings_dailyLimitWarning__iqKeG","preloader":"Warnings_preloader__YSYUI"};